import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import 'react-widgets/dist/css/react-widgets.css';
import Loader from 'react-loader-spinner';

class Telephony extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, hidePlatformDeletePopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteTelephonyApi(props, this.state.propsId)
                this.setState({
                    isChecked: true,
                    disabled: false
                })
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    isChecked: true,
                    disabled: false
                });
            }
        }];

        this.platformButtons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deletePlatformPropertyApi()
                this.setState({
                    isChecked: true,
                    disabledPlatformPropertyAdd: false
                })
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    isChecked: true,
                    disabledPlatformPropertyAdd: false
                });
            }
        }];

        this.state = {
            isChecked: false,
            data: [],
            disabled: false,
            editedId: '-1',
            hideDeletePopup: false,
            activateTelephony: '-1',
            deactivateTelephony: '-1',
            successResp: true,
            propertyChange: false,
            isEdit: false,
            telephonyServer: {},
            numOfBot: 0,
            telephonyPlatformProperties: [],
            disabledPlatformPropertyAdd: false,
            platformPropertiesEditedId: '-1',
            hidePlatformDeletePopup: false,
            disableAdd: true
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.socialPlatformPropertyVar = [];
        this.languageList = [];
        this.telephonyPlatformList = [];
        this.telephonyPlatformPropertyNames = [];
    }

    componentDidMount() {
        setTimeout(() => {
            this.getProjectDetails();
            this.fetchLanguagesApi();
            this.fetchPlatformsApi();
            this.fetchTelephonyCallHandleApi();
            this.fetchTelephonyProjectDeploymentApi();
            this.getProjectVoiceSetting();
            this.fetchPlatformPropertyNamesAPi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.getProjectDetails(event.projectId);
            thisController.fetchLanguagesApi(event.projectId);
            thisController.fetchPlatformsApi();
            thisController.fetchTelephonyCallHandleApi(event.projectId);
            thisController.fetchTelephonyProjectDeploymentApi(event.projectId);
            thisController.getProjectVoiceSetting(event.projectId);
            thisController.fetchPlatformPropertyNamesAPi();
        });
    }

    getProjectVoiceSetting = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var telephonyController = this;
        var enableVoice = false;
        $.ajax({
            url: "/api/voice-settings",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        enableVoice = res.result.enabled;
                    } else {
                        enableVoice = false;
                    }
                } else {
                    enableVoice = false;
                }
                if (!enableVoice) {
                    telephonyController.notifyNotAdded("Oops!you have not enabled voice capability");
                    var telephonyInterval = setInterval(function () {
                        clearTimeout(telephonyInterval);
                        window.location.href = '/platform/projectmgmt/voice';
                    }, 3000);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    getProjectDetails = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var telephonyComp = this;
        $.ajax({
            url: "/api/project-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.deployed == false) {
                        telephonyComp.notifyNotAdded("Oops!you have not deployed your project")
                        var voiceInterval = setInterval(function () {
                            clearTimeout(voiceInterval);
                            window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
                        }, 3000);
                    } else {
                        telephonyComp.fetchDeployedBotsNumberApi();
                    }
                } else {
                    telephonyComp.notifyNotAdded("Oops!you have not deployed your project")
                    var voiceInterval = setInterval(function () {
                        clearTimeout(voiceInterval);
                        window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
                    }, 3000);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchTelephonyProjectDeploymentApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var fetchDataContoller = this;
        $.ajax({
            url: "/api/telephony-project-deployment",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result != null) {
                        fetchDataContoller.state.telephonyServer = res.result;
                        fetchDataContoller.state.isEdit = true;
                        fetchDataContoller.state.isChecked = true;
                        fetchDataContoller.fetchPlatformPropertyNamesAPi();
                    } else {
                        fetchDataContoller.state.telephonyServer.telephonyServerUrl = "";
                    }
                    fetchDataContoller.setState(fetchDataContoller.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }


    notifyNotAdded(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;{message}</b>, {
            position: "top-center"
        });
    }

    saveTelephonyApi = (props, e) => {
        var addController = this;
        props.original.userName =
            document.getElementById("userName" + props.index).innerText;
        props.original.password =
            document.getElementById("password" + props.index).value;
        addController.state.editedId = "-1";
        addController.setState(this.state);

        var validateResult = addController.validateCells(props.original.userName, props.original.password);

        if (validateResult) {
            var addedData = {
                userName: props.original.userName,
                password: props.original.password,
                projectId: localStorage.getItem('currentProjectId'),
            };

            $.ajax({
                url: "/api/ip-telephony-bot",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(addedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        addController.notifyAdd("Telephony Property Added Successfully");
                        addController.fetchTelephonyCallHandleApi();
                        addController.state.disabled = false;
                    } else {
                        addController.notifyError(res.result);
                        addController.fetchTelephonyCallHandleApi();
                        addController.state.disabled = false;
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }

    notifyAdd = (message) => {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;
            {message}</b>, {
            position: "top-center",

        });
    }

    notifyUpdate = () => {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;
            Telephony Property Updated Successfully</b>, {
            position: "top-center",

        });
    }

    notifyError(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
    }

    updateTelephonyApi(props, e) {
        var updateController = this;
        props.original.userName =
            document.getElementById("userName" + props.index).innerText;
        props.original.password =
            document.getElementById("password" + props.index).value;

        var validateResult = updateController.validateCells(props.original.userName, props.original.password);

        if (validateResult) {
            var updatedData = {
                userName: props.original.userName,
                password: props.original.password,
                id: props.original.id,
                projectId: localStorage.getItem('currentProjectId'),
            };

            $.ajax({
                url: "/api/ip-telephony-bot",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updateController.state.editedId = "-1";
                        updateController.notifyUpdate();
                        updateController.fetchTelephonyCallHandleApi();
                    } else {
                        updateController.notifyError(res.result);
                    }
                },
                error: function (xhr) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Telephony Property Updated Successfully</b>, {
            position: "top-center",

        });
    }

    deleteTelephonyApi = (props, id) => {
        var deleteApiViewController = this;
        $.ajax({
            url: "/api/ip-telephony-bot/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    deleteApiViewController.state.deleteRow = true;
                    deleteApiViewController.state.hideDeletePopup = false;
                    deleteApiViewController.notifyDelete();
                    deleteApiViewController.fetchTelephonyCallHandleApi();
                    deleteApiViewController.setState(deleteApiViewController.state);
                } else {
                    deleteApiViewController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
        deleteApiViewController.fetchTelephonyCallHandleApi();
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Telephony Property Deleted Successfully</b>, {
            position: "top-center",

        });
    }

    fetchTelephonyCallHandleApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var fetchDataContoller = this;
        $.ajax({
            url: "/api/ip-telephony-bot",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    fetchDataContoller.state.data = res.result;
                    fetchDataContoller.state.selectedValue = [];

                    if (res.result.length == 0) {
                        fetchDataContoller.state.isChecked = false
                    } else if (res.result[0]["id"] != "" ||
                        res.result[0]["id"] != null) {
                        fetchDataContoller.state.isChecked = true;
                    } else {
                        fetchDataContoller.state.successResp = false;
                        fetchDataContoller.notifyError(res.result);
                    }
                    fetchDataContoller.setState(fetchDataContoller.state);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }

    validateCells(userName, password) {
        if ((userName == "" || password == "") || (userName == undefined || password == undefined)) {
            this.notifyMsgFieldEmpty();
            return false;
        } else {
            return true;
        }
    }


    validateUpdatedDate(value) {
        if (value == "" || value == null) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            Please fill all the fields</b>, {
            position: "top-center"
        });
    }

    notifyTelephonyServerFieldEmpty = () => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            Please fill all the field</b>, {
            position: "top-center"
        });
    }

    addRow = (data) => {
        this.state.data.unshift({});
        this.setState({
            disabled: true
        })
    }

    addPropertyRow = (data) => {
        this.state.telephonyPlatformProperties.unshift({});
        this.setState({
            disabledPlatformPropertyAdd: true
        })
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.original.id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    makePropertyCellEditable(props, e) {
        this.state.platformPropertiesEditedId = props.original.id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchTelephonyCallHandleApi()
        this.setState({
            disabled: false,
            isChecked: true
        })
    }

    refreshPropertyData = (id) => {
        var refreshContent = this
        refreshContent.fetchTelephonyPlatformPropertyApi()
        refreshContent.state.disabledPlatformPropertyAdd = false;
        refreshContent.state.isChecked = true;
        refreshContent.setState(refreshContent.state);
    }

    checkHandle = () => {
        if (document.getElementById("activate").checked == true) {
            this.activateTelephonyHandleChange();
        } else {
            this.deActivateAclWhatsappHandleChange();
        }
    }

    activateTelephonyHandleChange = (e) => {
        this.setState({
            isChecked: true
        })
    }

    deActivateAclWhatsappHandleChange = (e) => {
        this.setState({
            isChecked: false,
        })
    }

    handleSaveTelephonyServer = () => {
        if (document.getElementById("telephonyServerId").value == undefined ||
            document.getElementById("telephonyServerId").value == "") {
            this.notifyTelephonyServerFieldEmpty();
        } else if (document.getElementById("outboundPrefix").value == undefined ||
            document.getElementById("outboundPrefix").value == "") {
            this.notifyTelephonyServerFieldEmpty();
        } else if (document.getElementById("numberOfChannels").value == undefined ||
            document.getElementById("numberOfChannels").value == "") {
            this.notifyTelephonyServerFieldEmpty();
        } /*else if (document.getElementById("numberOfChannels").value > this.state.numOfBot) {
            this.notifyInvalidFields("Number of channels cannot be more than number of agents");
        } */ else {
            this.saveTelephonyServerApi();
        }
    }

    saveTelephonyServerApi = () => {
        var telephonyController = this;
        var telephonyServer = this.state.telephonyServer;

        var data = {
            projectId: localStorage.getItem('currentProjectId'),
            telephonyServerUrl: telephonyServer.telephonyServerUrl,
            outBoundCallPrefix: telephonyServer.outBoundCallPrefix,
            defaultLanguage: document.getElementById("defaultLanguage").value,
            numberOfChannels: telephonyServer.numberOfChannels,
            telephonyPlatform: telephonyServer.telephonyPlatform
        }

        $.ajax({
            url: "/api/telephony-project-deployment",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
            processData: false,
            contentType: "application/json; charset=UTF-8",
            success: function (res) {
                if (res.success === true) {
                    telephonyController.notifyAdd("Telephony Project Deployment details Added Successfully");
                    telephonyController.fetchTelephonyProjectDeploymentApi();
                    telephonyController.state.isEdit = true;
                } else {
                    telephonyController.notifyError(res.result);
                }
                telephonyController.setState(telephonyController.state);
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        })
    }

    validateCellsOnUpdation = (telephonyServer) => {
        if (telephonyServer.telephonyServerUrl == undefined || telephonyServer.telephonyServerUrl == "" ||
            telephonyServer.outBoundCallPrefix == undefined || telephonyServer.outBoundCallPrefix == "" ||
            telephonyServer.numberOfChannels == undefined) {
            this.notifyTelephonyServerFieldEmpty();
            return false;
        } /*else if (document.getElementById("numberOfChannels").value > this.state.numOfBot) {
            this.notifyInvalidFields("Number of channels cannot be more than number of agents");
            return false;
        } */ else {
            return true;
        }
    }

    handleUpdateTelephonyServerAPi = () => {
        var telephonyController = this;
        var telephonyServer = telephonyController.state.telephonyServer;

        if (telephonyController.validateCellsOnUpdation(telephonyServer)) {
            var data = {
                id: telephonyServer.id,
                projectId: localStorage.getItem('currentProjectId'),
                telephonyServerUrl: telephonyServer.telephonyServerUrl,
                outBoundCallPrefix: telephonyServer.outBoundCallPrefix,
                defaultLanguage: document.getElementById("defaultLanguage").value,
                numberOfChannels: telephonyServer.numberOfChannels,
                telephonyPlatform: telephonyServer.telephonyPlatform
            }
            $.ajax({
                url: "/api/telephony-project-deployment",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(data),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        telephonyController.notifyAdd("Telephony Project Deployment details Updated Successfully");
                        telephonyController.fetchTelephonyProjectDeploymentApi();
                        telephonyController.state.isEdit = true;
                    } else {
                        telephonyController.notifyError(res.result);
                    }
                    telephonyController.setState(telephonyController.state);
                },
                error: function (xhr) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }

    handleEdit = () => {
        this.setState({ isEdit: false });
    }

    handleChangeTelephonyServer = (e) => {
        var telephonyController = this;
        telephonyController.state.telephonyServer.telephonyServerUrl = e.target.value;
        telephonyController.setState(telephonyController.state);
    }

    handleChangeOutboundPrefix = (e) => {
        var telephonyController = this;
        telephonyController.state.telephonyServer.outBoundCallPrefix = e.target.value;
        telephonyController.setState(telephonyController.state);
    }

    handleChangeNumOfChannels = (e) => {
        var telephonyController = this;
        telephonyController.state.telephonyServer.numberOfChannels = e.target.value;
        telephonyController.setState(telephonyController.state);
    }

    notifyFailedActivate() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Failed to activate Telephony</b>, {
            position: "top-center"
        });
    }

    activateTelephonyApi = (props, e) => {
        var addController = this;
        $.ajax({
            url: "/api/activate-telephony-call-handle",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                "Content-type": "application/x-www-form-urlencoded; charset=utf-8"

            },
            data: { projectId: localStorage.getItem('currentProjectId') },
            success: function (res) {
                if (res.success === true) {
                    addController.state.checked = true;
                } else {
                    addController.notifyFailedActivate();
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        })
    }

    fetchLanguagesApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var telephonyController = this;
        telephonyController.languageList = [];
        $.ajax({
            url: "/api/project-languages-selected",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length !== 0) {
                        telephonyController.languageList = res.result;
                        telephonyController.setState(telephonyController.state);
                    } else {
                        telephonyController.notifyNoLangSelected();
                    }
                } else {
                    telephonyController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    fetchPlatformsApi = () => {
        var telephonyController = this;
        telephonyController.telephonyPlatformList = [];
        $.ajax({
            url: "/api/telephony-platform",
            async: false,
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length !== 0) {
                        telephonyController.telephonyPlatformList = res.result;
                        telephonyController.setState(telephonyController.state);
                    } else {
                        telephonyController.notifyNotAdded("Oops! Error occurred");
                    }
                } else {
                    telephonyController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyNoLangSelected() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops!you have not selected language for your project</b>, {
            position: "top-center"
        });
    }

    handleChangeLanguage = (e) => {
        this.state.telephonyServer.defaultLanguage = e.target.value;
        this.setState(this.state);
    }

    handleChangePlatform = (e) => {
        var telephonyController = this;
        telephonyController.state.telephonyServer.telephonyPlatform = e.target.value;
        telephonyController.setState(telephonyController.state);
    }

    fetchDeployedBotsNumberApi = () => {
        var telephonyComp = this;
        $.ajax({
            url: "/api/deployed-bots-number",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    telephonyComp.state.numOfBot = res.result;
                    telephonyComp.setState(telephonyComp.state);
                } else {
                    telephonyComp.state.numOfBot = 0;
                    telephonyComp.setState(telephonyComp.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyInvalidFields(message) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            {message}</b>, {
            position: "top-center"
        });
    }

    fetchTelephonyPlatformPropertyApi = () => {
        var fetchDataContoller = this;
        $.ajax({
            url: "/api/telephony-platform-properties",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                telephonyPlatform: fetchDataContoller.state.telephonyServer.telephonyPlatform
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    fetchDataContoller.state.telephonyPlatformProperties = res.result;
                    fetchDataContoller.setState(fetchDataContoller.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }

    saveTelephonyPlatformPropertyAPi = (props, e) => {
        var addController = this;
        props.original.name =
            document.getElementById("name" + props.index).value;
        props.original.propertyValue =
            document.getElementById("propertyValue" + props.index).value;
        addController.state.platformPropertiesEditedId = "-1";
        addController.setState(this.state);

        var validateResult = addController.validateCells(props.original.name, props.original.propertyValue);

        if (validateResult) {
            var addedData = {
                projectId: localStorage.getItem('currentProjectId'),
                name: props.original.name,
                propertyValue: props.original.propertyValue,
                telephonyPlatform: addController.state.telephonyServer.telephonyPlatform
            };

            $.ajax({
                url: "/api/telephony-platform-properties",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(addedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        addController.notifyAdd("Telephony Platform Property Added Successfully");
                        addController.fetchTelephonyPlatformPropertyApi();
                        addController.state.disabledPlatformPropertyAdd = false;
                    } else {
                        addController.notifyError(res.result);
                        addController.fetchTelephonyPlatformPropertyApi();
                        addController.state.disabledPlatformPropertyAdd = false;
                    }
                },
                error: function (xhr) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }

    updateTelephonyPlatformPropertyAPi(props, e) {
        var updateController = this;
        props.original.name =
            document.getElementById("name" + props.index).value;
        props.original.propertyValue =
            document.getElementById("propertyValue" + props.index).value;

        var validateResult = updateController.validateCells(props.original.name, props.original.propertyValue);

        if (validateResult) {
            var updatedData = {
                id: props.original.id,
                projectId: localStorage.getItem('currentProjectId'),
                name: props.original.name,
                propertyValue: props.original.propertyValue,
                telephonyPlatform: updateController.state.telephonyServer.telephonyPlatform
            };

            $.ajax({
                url: "/api/telephony-platform-properties",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        updateController.state.platformPropertiesEditedId = "-1";
                        updateController.notifyAdd("Telephony Platform Property Updated Successfully");
                        updateController.fetchTelephonyPlatformPropertyApi();
                    } else {
                        updateController.notifyError(res.result);
                    }
                },
                error: function (xhr) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            })
        }
    }

    fetchPlatformPropertyNamesAPi = () => {
        var telephonyComp = this;
        $.ajax(
            {
                url: "/api/telephony-platform-property-names",
                async: false,
                method: 'GET',
                data: {
                    telephonyPlatform: telephonyComp.state.telephonyServer.telephonyPlatform
                },

                headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {
                    if (res.success === true) {
                        telephonyComp.telephonyPlatformPropertyNames = res.result;
                        if (res.result.length > 0) {
                            telephonyComp.state.disableAdd = false;
                        } else {
                            telephonyComp.state.disableAdd = true;
                        }
                        telephonyComp.setState(telephonyComp.state);
                        telephonyComp.fetchTelephonyPlatformPropertyApi();
                    }
                    else {
                        telephonyComp.notifyError(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            }
        )
    }

    optionHandleChange = (props, e) => {
        console.log("Property name", e.target.value)
        props.original.name = e.target.value;
        this.setState(this.state);
    }

    deletePlatformPropertyApi = () => {
        var deleteApiViewController = this;
        $.ajax({
            url: "/api/telephony-platform-properties/" + deleteApiViewController.state.propsId,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    deleteApiViewController.state.hidePlatformDeletePopup = false;
                    deleteApiViewController.notifyDelete();
                    deleteApiViewController.fetchTelephonyPlatformPropertyApi();
                    deleteApiViewController.setState(deleteApiViewController.state);
                } else {
                    deleteApiViewController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    render() {
        const { data } = this.state
        const columns = [
            {
                Header: <b>UserName</b>,
                width: 270,
                textAlign: 'screenLeft',
                accessor: 'username',
                sortable: false,
                Cell: props => {
                    return (
                        <div
                            Align="left" className="input"
                            style={{
                                padding: '8px 2px 8px 8px', width: '98%', borderBottom: 'none',
                                border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                                    '1px solid #D2D4DC' : 'none', borderRadius:
                                    (props.original.id == undefined) ? '2px' : 'none'
                            }}
                            suppressContentEditableWarning
                            contentEditable={!((props.original.id == undefined) ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}

                            type="text" id={"userName" + props.index} value={props.original.id == undefined ? "" :
                                props.original.userName} >{props.original.userName}
                        </div>
                    )
                }
            },
            {
                Header: <b>Password</b>,
                accessor: 'password',
                sortable: false,
                Cell: props =>
                (<input
                    Align="left"
                    style={{
                        padding: '8px 0px 8px 8px',
                        width: '98%',
                        borderBottom: 'none',
                        border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                            '1px solid #D2D4DC' : 'none',
                        borderRadius: (props.original.id == undefined) ? '2px' : 'none',
                        maxHeight: "14px"
                    }}
                    suppressContentEditableWarning
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}
                    type="password" id={"password" + props.index}
                    defaultValue={props.original.id == undefined ? "" :
                        props.original.password}
                    disabled={(props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId} />
                )
            },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 100,
                sortable: false,
                Cell: props => (
                    <div id="action">
                        {/* edit button */}
                        <div style={{ marginTop: '-9px' }}>
                            <p>
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive"
                                        title={
                                            (props.original.id == undefined) || (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                        style={{
                                            marginTop: '8px',
                                            backgroundColor: '#282a65',
                                            borderRadius: '5px',
                                            padding: '1px',
                                            cursor: 'pointer'
                                        }}
                                        src={(props.original.id == null) ?
                                            this.saveImageSrc :
                                            ((props.original.id != this.state.editedId) ?
                                                this.editImageSrc : this.saveImageSrc)}
                                        onClick={(e) => {
                                            (props.original.id == null) ?
                                                this.saveTelephonyApi(props, e) :
                                                (props.original.id == this.state.editedId) ?
                                                    this.updateTelephonyApi(props, e) :
                                                    this.makeCelleditable(props, e);
                                        }}
                                    /></button>
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                        title="Delete"
                                        style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: 'pointer' }}

                                        onClick={(e) => {
                                            (props.original.id == undefined) ? this.fetchTelephonyCallHandleApi() :
                                                this.setState({
                                                    hideDeletePopup: true, deletePropIndex: props.index,
                                                    propsId: props.original.id
                                                })
                                        }}
                                    /></button>
                            </p>
                        </div>
                    </div>
                ),
            },
        ];
        const platformPropertyColumns = [
            {
                Header: <b>Name</b>,
                width: 270,
                textAlign: 'screenLeft',
                accessor: 'name',
                sortable: false,
                Cell: props => {
                    return (
                        <div className="container-fluid" style={{ textAlign: "right" }}>
                            <div className="container-fluid" style={{ textAlign: "right" }}>
                                <select className="input-group form-control select2 " onChange={(e) => this.optionHandleChange(props, e)}
                                    value={props.original.name} id={"name" + props.index}
                                    style={{
                                        background: 'white', border: 'none', border: (props.original.id == undefined ||
                                            props.original.id == this.state.platformPropertiesEditedId) ? '1px solid #D2D4DC' : 'none',
                                        borderRadius: (props.original.id == undefined) ? '2px' : 'none'
                                    }}
                                    disabled={(props.original.id == null) ? false : props.original.id != this.state.platformPropertiesEditedId}>
                                    {this.telephonyPlatformPropertyNames.map(telephonyPlatformPropertyName => (
                                        <option key={telephonyPlatformPropertyName} value={telephonyPlatformPropertyName} >
                                            {telephonyPlatformPropertyName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: <b>Property Value</b>,
                accessor: 'propertyValue',
                sortable: false,
                Cell: props =>
                (<input
                    Align="left"
                    style={{
                        padding: '8px 0px 8px 8px',
                        width: '98%',
                        borderBottom: 'none',
                        border: (props.original.id == undefined || props.original.id == this.state.platformPropertiesEditedId) ?
                            '1px solid #D2D4DC' : 'none',
                        borderRadius: (props.original.id == undefined) ? '2px' : 'none',
                        maxHeight: "14px"
                    }}
                    suppressContentEditableWarning
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.platformPropertiesEditedId) ? "plaintext-only" : false}
                    type="text" id={"propertyValue" + props.index}
                    defaultValue={props.original.id == undefined ? "" :
                        props.original.propertyValue}
                    disabled={(props.original.id == undefined) ? false :
                        props.original.id != this.state.platformPropertiesEditedId} />
                )
            },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 100,
                sortable: false,
                Cell: props => (
                    <div id="action">
                        {/* edit button */}
                        <div style={{ marginTop: '-9px' }}>
                            <p>
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive"
                                        title={
                                            (props.original.id == undefined) || (props.original.id == this.state.platformPropertiesEditedId) ? 'Save' : 'Edit'}
                                        style={{
                                            marginTop: '8px',
                                            backgroundColor: '#282a65',
                                            borderRadius: '5px',
                                            padding: '1px',
                                            cursor: 'pointer'
                                        }}
                                        src={(props.original.id == null) ?
                                            this.saveImageSrc :
                                            ((props.original.id != this.state.platformPropertiesEditedId) ?
                                                this.editImageSrc : this.saveImageSrc)}
                                        onClick={(e) => {
                                            (props.original.id == null) ?
                                                this.saveTelephonyPlatformPropertyAPi(props, e) :
                                                (props.original.id == this.state.platformPropertiesEditedId) ?
                                                    this.updateTelephonyPlatformPropertyAPi(props, e) :
                                                    this.makePropertyCellEditable(props, e);
                                        }}
                                    /></button>
                                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                                    <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                        title="Delete"
                                        style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: 'pointer' }}

                                        onClick={(e) => {
                                            (props.original.id == undefined) ? this.fetchTelephonyPlatformPropertyApi() :
                                                this.setState({
                                                    hidePlatformDeletePopup: true, propsId: props.original.id
                                                })
                                        }}
                                    /></button>
                            </p>
                        </div>
                    </div>
                ),
            },
        ];
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <ToastContainer className="Toast-at-center" />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">


                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/div-as-input-field.css" />

                    <div className="container-fluid">
                        <div className="row" style={{ marginLeft: '2px' }}>
                            <label>Activate Telephony</label>
                            <label class="switch" style={{ marginLeft: '15px' }}>

                                <input type="checkbox"
                                    id={"activate"}
                                    onChange={this.checkHandle}
                                    checked={this.state.isChecked}
                                />
                                <span class="slider round"></span>
                            </label>
                        </div> <br />
                        <div style={{ display: this.state.isChecked ? 'block' : 'none' }}>
                            <div>
                                <label style={{ marginLeft: "10px", width: '14%' }}>Telephony Server : </label>&nbsp;
                                <input placeholder="Eg,sip://serverdomain;portNumber"
                                    value={this.state.telephonyServer.telephonyServerUrl}
                                    disabled={this.state.isEdit}
                                    id="telephonyServerId"
                                    onChange={this.handleChangeTelephonyServer}
                                    style={{
                                        width: '35%',
                                        borderBottom: 'none',
                                        border: !this.state.isEdit ? '1px solid #D2D4DC' : 'none',
                                        borderRadius: '2px',
                                        paddingLeft: '5px',
                                        background: 'transparent'
                                    }} />
                            </div>
                            <div style={{ marginTop: '10px' }}>
                                <label style={{ marginLeft: "10px", width: '14%' }}>Outbound Prefix : </label>&nbsp;
                                <input placeholder="Enter Outbound Prefix"
                                    value={this.state.telephonyServer.outBoundCallPrefix}
                                    disabled={this.state.isEdit}
                                    id="outboundPrefix"
                                    onChange={this.handleChangeOutboundPrefix}
                                    style={{
                                        width: '35%',
                                        borderBottom: 'none',
                                        border: !this.state.isEdit ? '1px solid #D2D4DC' : 'none',
                                        borderRadius: '2px',
                                        paddingLeft: '5px',
                                        background: 'transparent'
                                    }} />
                            </div>
                            <div style={{ marginTop: '10px' }}>
                                <label style={{ marginLeft: "10px", width: '14%' }}>Default Language : </label>&nbsp;
                                <select id="defaultLanguage"
                                    value={this.state.telephonyServer.defaultLanguage}
                                    onChange={this.handleChangeLanguage}
                                    disabled={this.state.isEdit}
                                    style={{
                                        width: '35.5%', height: '2.5rem', borderRadius: '2px',
                                        background: 'transparent', paddingLeft: '5px', color: 'black',
                                        border: '1px solid #D2D4DC'

                                    }}>
                                    {this.languageList.map((language) =>
                                        <option value={language.code}>{language.name}</option>
                                    )}
                                </select>
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                <label style={{ marginLeft: "10px", width: '14%' }}>Number Of Channels : </label>&nbsp;
                                <input placeholder={this.state.telephonyServer.numberOfChannels === null && this.state.isEdit ? "" : "Enter Number Of Channels"}
                                    value={this.state.telephonyServer.numberOfChannels}
                                    disabled={this.state.isEdit}
                                    id="numberOfChannels"
                                    type="number" pattern="[0-9]*" inputmode="numeric"
                                    onChange={this.handleChangeNumOfChannels}
                                    style={{
                                        width: '35%',
                                        borderBottom: 'none',
                                        border: !this.state.isEdit ? '1px solid #D2D4DC' : 'none',
                                        borderRadius: '2px',
                                        paddingLeft: '5px',
                                        background: 'transparent'
                                    }} />
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                <label style={{ marginLeft: "10px", width: '14%' }}>Platform : </label>&nbsp;
                                <select id="telephonyPlatform"
                                    value={this.state.telephonyServer.telephonyPlatform}
                                    onChange={this.handleChangePlatform}
                                    disabled={this.state.isEdit}
                                    style={{
                                        width: '35.5%', height: '2.5rem', borderRadius: '2px',
                                        background: 'transparent', paddingLeft: '5px', color: 'black',
                                        border: '1px solid #D2D4DC'

                                    }}>
                                    {this.telephonyPlatformList.map((telephonyPlatform) =>
                                        <option value={telephonyPlatform.code}>{telephonyPlatform.name}</option>
                                    )}
                                </select>
                            </div>
                            <div align="right" style={{ width: '49.5%', marginLeft: '15px' }}>
                                <button className="btn action-button "
                                    title={this.state.isEdit ? "Edit" : "Save"}
                                    onClick={this.state.isEdit ? this.handleEdit : this.state.telephonyServer.id == undefined ? this.handleSaveTelephonyServer : this.handleUpdateTelephonyServerAPi} >
                                    {this.state.isEdit ? "Edit" : "Save"}
                                </button>
                            </div><br />
                            <div className='row'>
                                <div className="col-sm-6" style={{ margin: '30px 0px 10px 0px' }}>
                                    <div className="col-sm-6">
                                        <h6 className="nav-item" style={{
                                            color: '#282a65',
                                            marginTop: '24px', marginLeft: '2px'
                                        }}>Credentials of Agent</h6>
                                        <label>(Assign credentials for dhee agents to login to your telephony server)</label>
                                    </div>
                                    {/* Add button and refresh button*/}
                                    <div className="col-sm-6" Align='right'>
                                        <button className="btn action-button "
                                            title="Add"
                                            id="addMsg"
                                            onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow} >
                                            <img src="assets/images/add_white_24dp.png" />
                                        </button>
                                        <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                            <img src="./assets/images/refresh_white_24dp.png"></img>
                                        </button>
                                    </div>

                                    <div className="content"
                                        style={{ display: this.state.isChecked ? 'block' : 'none' }}>
                                        <div className="col-lg-12 ">
                                            <div className="card" >
                                                <ReactTable
                                                    data={data}
                                                    columns={columns}
                                                    defaultPageSize={5}
                                                    pageSizeOptions={[5, 10, 15]}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6" style={{ margin: '75px 0px 10px 0px' }}>
                                    <div className="col-sm-6">
                                        <h6 className="nav-item" style={{
                                            color: '#282a65',
                                            marginTop: '24px', marginLeft: '2px'
                                        }}>Telephony Platform Properties</h6>
                                    </div>
                                    {/* Add button and refresh button*/}
                                    <div className="col-sm-6" Align='right'>
                                        <button className="btn action-button "
                                            title="Add"
                                            id="addMsg"
                                            disabled={this.state.disableAdd}
                                            onClick={this.state.disabledPlatformPropertyAdd ? this.notifyMsgFieldEmpty : this.addPropertyRow} >
                                            <img src="assets/images/add_white_24dp.png" />
                                        </button>
                                        <button onClick={this.refreshPropertyData} className="btn action-button" title="Refresh">
                                            <img src="./assets/images/refresh_white_24dp.png"></img>
                                        </button>
                                    </div>

                                    <div className="content"
                                        style={{ display: this.state.isChecked ? 'block' : 'none' }}>
                                        <div className="col-lg-12 ">
                                            <div className="card" >
                                                <ReactTable
                                                    data={this.state.telephonyPlatformProperties}
                                                    columns={platformPropertyColumns}
                                                    defaultPageSize={5}
                                                    pageSizeOptions={[5, 10, 15]}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*Dialog Component For Deletion Confirmation*/}
                        <DialogComponent width='400px' animationSettings={this.settings}
                            header='Telephony' showCloseIcon={true} buttons={this.buttons}
                            ref={dialog => this.dialogInstance = dialog}
                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                content="" />&nbsp;Do you want to delete the Telephony property?<br />Note: Press 'Yes' to delete or press 'No' to decline.

                        </DialogComponent>

                        {/*Dialog Component For Deletion Confirmation of Telephony platform*/}
                        <DialogComponent width='400px' animationSettings={this.settings}
                            header='Telephony' showCloseIcon={true} buttons={this.platformButtons}
                            ref={dialog => this.dialogInstance = dialog}
                            visible={this.state.hidePlatformDeletePopup} close={this.dialogClose}>
                            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                content="" />&nbsp;Do you want to delete the Telephony platform property?<br />Note: Press 'Yes' to delete or press 'No' to decline.

                        </DialogComponent>

                    </div>
                </div>

            </div >
        )

    }
}

export default Telephony;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/Telephony.js